import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const AgreedPlace: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.373 11.773L9.687 2.625 0 11.773l1.373 1.454 1.314-1.24V20a1 1 0 001 1h12a1 1 0 001-1v-8.013L18 13.227l1.373-1.454zm-4.686-1.675l-5-4.723-5 4.723V19h10v-8.902z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M24 17h-8v-2h8v2z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M22 21v-6h1v6h-1z" />
    <path d="M18 19h3v2h-3z" />
  </SvgIcon>
)
